import { Box, makeStyles, Theme } from '@material-ui/core'
import TooltipButton from '@src/components/TooltipButton'
import MessageIcon from '@src/icons/MessageIcon'
import LocalShippingIcon from '@src/icons/LocalShippingIcon'
import { FormattedMessage } from 'react-intl'
import clsx from 'clsx'

const useStyles = makeStyles((theme: Theme) => ({
  tooltip: {
    padding: '0 !important',
    minWidth: '165px',
  },
  tooltipXL: {
    maxWidth: '600px',
    minWidth: '600px',
  },
  noCommentBadge: {
    '& > path:first-child': { fill: theme.palette.grey[400] },
  },
  header: {
    background: theme.palette.background.grey,
    padding: theme.spacing(3, 5),
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
  },
  body: {
    padding: theme.spacing(5, 4),
    gap: theme.spacing(4),
  },
  bodyXL: {
    display: 'flex',
  },
  lot: {
    fontSize: theme.typography.pxToRem(12),
    lineHeight: theme.typography.pxToRem(10),
    marginTop: theme.spacing(-2),
  },
}))

export enum MDTooltipVariants {
  comments = 'comments',
  delivery = 'delivery',
  lotNumber = 'lot-number',
}

const MDTooltip = ({
  children,
  variant,
  title,
  count = 0,
}: {
  children: any
  variant: MDTooltipVariants
  title: any
  count?: number
}) => {
  const classes = useStyles()

  const renderIcon = () => {
    if (variant === MDTooltipVariants.comments && count > 0) {
      return <MessageIcon />
    } else if (variant === MDTooltipVariants.lotNumber) {
      return (
        <Box className={classes.lot}>
          +{count} <FormattedMessage id="MORE" defaultMessage="More" />
        </Box>
      )
    } else {
      return <LocalShippingIcon />
    }
  }

  return (
    <>
      {variant === MDTooltipVariants.comments && count === 0 ? (
        <MessageIcon className={classes.noCommentBadge} />
      ) : (
        <TooltipButton
          classNameTooltip={clsx(classes.tooltip, {
            [classes.tooltipXL]: variant !== MDTooltipVariants.lotNumber,
          })}
          toolTipText={
            <>
              <Box className={classes.header}>{title}</Box>
              <Box
                className={clsx(classes.body, {
                  [classes.bodyXL]: variant !== MDTooltipVariants.lotNumber,
                })}
              >
                {children}
              </Box>
            </>
          }
          leaveDelay={0}
          placement="left"
          showOutline={false}
        >
          {renderIcon()}
        </TooltipButton>
      )}
    </>
  )
}

export default MDTooltip
